import { Button, Divider } from "@shopify/polaris";
import styles from "../BundleBuilder.module.css";
import { useContext } from "react";
import { BundleBuilderContext, BundleBuilderContextType } from "../BundleBuilder";
import BundleBuilderAdvanced from "./BundleBuilderAdvanced";
import BundleBuilderTargetingForm from "./BundleBuilderTargetingForm";
import { BundleTypes } from "../../constants";

const BundleBuilderTargetForm = () => {
    const { handleNext } = useContext(BundleBuilderContext) as BundleBuilderContextType;

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: "4px" }}>
                <Divider borderColor="border" />
            </div>
            <div className={styles.collapsibleFormBox} style={{ marginBottom: "-12px" }}>
                <BundleBuilderAdvanced bundleType={BundleTypes.BUNDLE_BUILDER} />
            </div>
            <BundleBuilderTargetingForm />
            <div className={styles.dividerStyle}>
                <Divider borderColor="border" />
            </div>

            <div className={styles.bottomRowCta}>
                <Button onClick={() => handleNext(1, "Design")}>Back</Button>
            </div>
        </div>
    );
};

export default BundleBuilderTargetForm;
